import { render, staticRenderFns } from "./ProjectViewRequestIndex.vue?vue&type=template&id=330dde1c&"
import script from "./ProjectViewRequestIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectViewRequestIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports